module.exports = __webpack_public_path__ + "static/img/jump.bb9babf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump.png
// module id = WVTH
// module chunks = 2